import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

import { MOBILE_BREAKPOINT } from "features/IikoIntegration/constants";

export const Card = styled.section`
    background: ${colors.surface};
    border-radius: ${radii.base};
    box-shadow: ${shadows.panel};
    padding: 24px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        padding: 16px;
    }
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: block;
    }
`;

export const Divider = styled.hr`
    margin: 20px 0;
    border: 0;
    border-top: 1px solid ${colors.borderSoft};
`;

export const Text = styled.div`
    min-width: 0;
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 1.0625rem;
    font-weight: 600;
    line-height: 1.2;
    color: ${colors.textPrimary};
`;

export const Description = styled.p`
    margin: 4px 0 0;
    font-size: 12px;
    color: ${colors.textSecondary};
`;

export const Action = styled.div`
    flex: 0 0 auto;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        margin-top: 14px;

        button {
            width: 100%;
        }
    }
`;
